import { FC, ReactNode } from "react";
import style from "./MiddleCard.module.scss";
import Typhography from "../../../../shared/Typhography/Typhography";
import cx from "classnames";
import { AnimatedCounter } from "react-animated-counter";
import { Skeleton } from "@chakra-ui/react";

export const MiddleCard: FC<{
  title: string;
  /** `null`/assente = nessun dato: la card mostra "-", non uno zero. */
  label?: number | null;
  showPercentageLabel?: boolean;

  sublabel: string;
  showPercentage?: boolean;
  loading?: boolean;
  /** `null` = non c'è un periodo precedente con cui confrontarsi: badge nascosto. */
  percentage: number | null;
  creatingPdf: boolean;
  BottomRightComponent?: ReactNode;
}> = ({
  label,
  title,
  percentage,
  creatingPdf,
  sublabel,
  showPercentage = true,
  showPercentageLabel = true,
  BottomRightComponent,
  loading,
}) => {
  return (
    <Skeleton loading={loading}>
      <div className={style.container}>
        <Typhography size="bold-14">{title}</Typhography>
        <div className={style.bottomContainer}>
          <div className="d-flex align-items-center">
            {typeof label === "number" ? (
              <>
                {creatingPdf ? (
                  <Typhography size="bold-24">{label.toFixed(0)}</Typhography>
                ) : (
                  <AnimatedCounter
                    containerStyles={{ margin: 0 }}
                    includeDecimals={false}
                    fontSize={"24px"}
                    digitStyles={{
                      fontWeight: 700,
                    }}
                    value={label}
                  ></AnimatedCounter>
                )}
                {/* <Typhography size="bold-24">{label}</Typhography> */}
                {showPercentageLabel && (
                  <Typhography size="bold-24">%</Typhography>
                )}
              </>
            ) : (
              <Typhography size="bold-24">-</Typhography>
            )}
          </div>
          {BottomRightComponent ? (
            BottomRightComponent
          ) : (
            <div className="d-flex flex-column gap-1">
              {/* Nessun confronto possibile → nessun badge: un "0%" inventato
                  si legge come "stabile", che è un'affermazione diversa. */}
              {typeof percentage === "number" && (
                <div
                  className={cx(style.percentageContainer, {
                    [style.bad]: percentage <= 0,
                    [style.good]: percentage > 0,
                  })}
                >
                  <Typhography size="bold-12">
                    {showPercentage ? "" : percentage < 0 ? "" : "+"}

                    {percentage}
                    {showPercentage ? "%" : ""}
                  </Typhography>
                </div>
              )}
              <Typhography size="regular-12" className={style.sublabel}>
                {sublabel}
              </Typhography>
            </div>
          )}
        </div>
      </div>
    </Skeleton>
  );
};

// numero test effettuati
// invece di readiness oggettiva  -> recupero oggetivo
// invece di readiness soggettiva -> recupero soggetivo
// aggiustare test da dashbaord
// togliere orario obbgligatorio nei test
// filtrare eventi calendario per squadra
